"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconInstantPricing = function SvgIconInstantPricing(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "instant pricing icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Instant Pricing Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M22.71 23.47a.374.374 0 01-.06.402 12.696 12.696 0 00-3.15 8.378c0 .12 0 .237.012.352a.376.376 0 01-.375.398H13.5a1.5 1.5 0 010-3h3.75a.75.75 0 00.75-.75v-.75a.75.75 0 00-.75-.75H9a3 3 0 01-3-3V9a3 3 0 013-3h21a3 3 0 013 3v10.139a.375.375 0 01-.398.373c-.116-.012-.233-.012-.352-.012-.61.002-1.217.05-1.82.141a.375.375 0 01-.43-.37V9.75a.75.75 0 00-.75-.75H9.75a.75.75 0 00-.75.75V22.5a.75.75 0 00.75.752h12.618a.372.372 0 01.342.219zM31.5 21c5.796.007 10.493 4.704 10.5 10.5C42 37.299 37.299 42 31.5 42S21 37.299 21 31.5 25.701 21 31.5 21zm0 2.42c-.634 0-1.154.487-1.207 1.107l-.005.104v.496a.402.402 0 01-.323.396 3.368 3.368 0 00-.724 6.374l.141.06 3.336 1.334a.956.956 0 01-.266 1.84l-.091.004h-3.284a1.212 1.212 0 00-.105 2.418l.105.005h.808c.2 0 .367.146.398.338l.005.066v.408a1.212 1.212 0 002.42.105l.004-.105v-.497a.402.402 0 01.323-.396 3.368 3.368 0 00.725-6.38l-.142-.059-3.336-1.334a.955.955 0 01.266-1.838l.091-.004h3.284a1.212 1.212 0 00.105-2.418l-.105-.005h-.808a.404.404 0 01-.398-.338l-.005-.066v-.404c0-.669-.543-1.211-1.212-1.211z"
  }));
};

var _default = SvgIconInstantPricing;
exports.default = _default;